import { j as o } from "../../../../jsx-runtime-p91LotPX.mjs";
import { A as f } from "../../../../AntDrawer-ChgesM8B.mjs";
import { GrowTypography as u } from "../../../Typography/AntTypography.js";
import { CloseIcon as p } from "../../../../Icons/Icons.js";
import { useState as g, useEffect as v } from "react";
import C from "./ColumnArea.js";
import { D as x } from "../../../../ColumnSearch-DyjTqam1.mjs";
import { T as y } from "../../../../index-BP092b3A.mjs";
function O(e) {
  const [s, r] = g(!1), n = /* @__PURE__ */ o.jsx(u.Text, { fs: "16", children: e.title ? e.title : "Organize Columns" });
  v(() => {
    var t;
    const m = () => r(!0), d = () => r(!1);
    return (t = e.api) == null || t.addEventListener("columnCustomOpen", m), () => {
      var a;
      return (a = e.api) == null ? void 0 : a.removeEventListener("columnCustomOpen", d);
    };
  }, [e.api, r]);
  const l = /* @__PURE__ */ o.jsx(y, { title: "Close", children: /* @__PURE__ */ o.jsx(p, { color: "var(--gray-7)" }) });
  function i() {
    r(!1);
  }
  const c = /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(x, { style: {
      borderColor: "var(--gray-5)",
      margin: "var(--space-8) 0 var(--space-12) 0"
    } }),
    e.footer
  ] });
  return /* @__PURE__ */ o.jsx(f, { className: "column-custom-drawer", open: s, closable: !0, closeIcon: l, mask: !1, design: "close_position", title: n, width: 400, onClose: i, getContainer: !1, styles: {
    body: {
      overflow: "hidden auto",
      padding: "var(--space-16)"
    },
    header: {
      background: "var(--gray-2)",
      borderColor: "var(--gray-5)"
    },
    footer: {
      border: 0,
      padding: "var(--space-16) var(--space-24)",
      paddingTop: 0
    },
    wrapper: e.wrapperStyles
  }, footer: e.footer ? c : null, children: /* @__PURE__ */ o.jsx(C, { ...e }) });
}
export {
  O as default
};
//# sourceMappingURL=ColumnSortDrawer.js.map
